<template>
    <div class="jieguo">
        <div class="jg-notice">
            <div class="jg-msg">
                <div class="jg-msg__icon-area">
                    <i class="el-icon-success" style="color: #11b95c;font-size:100px">
                    </i>
                </div>
                <div class="jg-msg__text-area">
                    <h2 class="jg-msg__title">授权成功</h2>
                    <p class="jg_msg__desc">您可能需要进行下列操作</p>
                </div>
                <div>
                    <van-button type="default" id="backButton" style="height: 40px;width: 160px;" @click="goBackToMiniProgram">返回
                    </van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import wx from'weixin-js-sdk'

    export default {
        name: 'home',
        components: {},
        data() {
            return {
                deptId: '',
                type: '',
            }
        },
        created() {
            document.title = "授权"
        },
        methods: {
            // 在 Vue 页面中触发返回操作
             goBackToMiniProgram() {
                     wx.miniProgram.switchTab({
                         url:'/pages/my/index',
                         success(res){
                             console.log('跳转成功',res)
                         },fail(err) {
                             console.log('跳转失败',err)
                         },complete() {
                         console.log("执行");
                     }
                 })
            }
        },
    }
</script>

<style>
    .jieguo {

    }

    .jg-notice {
        margin: auto;
        font-size: 18px;
        text-align: center;
        margin-top: 16%;
    }

    .jg-msg {
        padding-top: 36px;
        text-align: center;
    }

    .jg-msg__icon-area {
        margin-bottom: 18px;
    }

    .jg-msg__text-area {
        margin-bottom: 18px;
        padding: 0 20px;
    }

    .jg-msg__title {
        margin-bottom: 5px;
        font-weight: 400;
        font-size: 18px;
    }

    .jg_msg__desc {
        margin-top: 8px;
        font-size: 15px;
        color: #888888;
    }
</style>
